import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectProfitData, selectProfitStatus } from '../../selectors/selectProfit';
import { EProfitStatus } from '../../types/page';
import { EmptyPage } from '../../components/EmptyPage';
import { LoadingPage } from '../../components/LoadingPage';
import { ProfitContainer } from './ProfitContainer';

export const ProfitContainerLoad: React.FC = () => {
  const profitData = useSelector(selectProfitData);
  const profitStatus = useSelector(selectProfitStatus);

  if (profitStatus === EProfitStatus.loading) {
    return <LoadingPage />;
  }

  if (profitStatus === EProfitStatus.failed || profitData === null) {
    return <EmptyPage />;
  }

  return <ProfitContainer />;
};
